<sc-flex vertical stretchContent fitHeight>
  <sc-flex-fitting-content vertical>
    <sc-scroll-pane>

      @for (position of taskPositions; track position) {
        <ng-container class="position">
          <sc-sub-title>{{position.name}}</sc-sub-title>
          <sc-content-spacer vertical></sc-content-spacer>
          @for (t of position.tasks; track t) {
            <app-task-list-entry [task]="t" [selected]="t === selectedTask" (click)="selectTask(t)"></app-task-list-entry>
            <sc-list-spacer></sc-list-spacer>
          }
        </ng-container>
      }

    </sc-scroll-pane>
  </sc-flex-fitting-content>
  <app-service-response [responseMessages]="responseMessages"></app-service-response>
  <sc-padding>
    <sc-flex>

      <sc-content-spacer grow></sc-content-spacer>

      <sc-action-icon (click)="showProcessingHint(selectedTask)" iconClass="fa-question"
        [disabled]="selectedTask == null ||selectedTask.processingHint == null || selectedTask.processingHint.length == 0">
      </sc-action-icon>

      <sc-content-spacer></sc-content-spacer>

      @if (isMessageTask(selectedTask)) {
        <sc-button (click)="completeTask(selectedTask)" class="confirm-button"
          [disabled]="isCompleteMessageTaskDisabled(selectedTask)"
          dictionaryKey="tmc-yard.ui.task-position-details.action.complete-message">
        </sc-button>
      }

      @if (isCheckTask(selectedTask)) {
        <sc-button (click)="completeTask(selectedTask)" class="confirm-button"
          [disabled]="isCompleteTaskDisabled(selectedTask)"
          dictionaryKey="tmc-yard.ui.task-position-details.action.complete-check">
        </sc-button>
      }

      @if (isDocumentTask(selectedTask)) {
        <sc-button (click)="completeDocumentTask(selectedTask)" class="confirm-button"
          [label]="getDocumentTaskTitle(selectedTask)">
        </sc-button>
      }

      @if (isPictureTask(selectedTask)) {
        <sc-button mat-flat-button class="confirm-button" [disabled]="isCompleteTaskDisabled(selectedTask)"
          (click)="pictureInput.click()"
          dictionaryKey="tmc-yard.ui.task-position-details.action.complete-picture">
          <input id="picture-btn" #pictureInput name="picture-btn" type="file" accept="image/*"
            (change)="completePictureTask($event)" style="display: none;" />
          </sc-button>
        }
      </sc-flex>
    </sc-padding>
  </sc-flex>
